var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp_b_vuejs_container"},[_c('b-card',{class:_vm.classEntity,scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.entity.label))])]},proxy:true}])},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }